import {WeekDays} from 'stores/CreateClassStore';

export const WEEK_DAYS = [
  {
    abbreviation: 'Mon',
    title: 'Monday',
    day: WeekDays.monday,
    times: [],
  },
  {
    abbreviation: 'Tue',
    title: 'Tuesday',
    day: WeekDays.tuesday,
    times: [],
  },
  {
    abbreviation: 'Wed',
    title: 'Wednesday',
    day: WeekDays.wednesday,
    times: [],
  },
  {
    abbreviation: 'Thu',
    title: 'Thursday',
    day: WeekDays.thursday,
    times: [],
  },
  {
    abbreviation: 'Fri',
    title: 'Friday',
    day: WeekDays.friday,
    times: [],
  },
  {
    abbreviation: 'Sat',
    title: 'Saturday',
    day: WeekDays.saturday,
    times: [],
  },
  {
    abbreviation: 'Sun',
    title: 'Sunday',
    day: WeekDays.sunday,
    times: [],
  },
];

export const HOURS_DATA = ['0', '1'];
export const MINUTES_DATA = ['0', '15', '30', '45'];
export const DURATION_DATA_FOR_WEB = [
  '15',
  '30',
  '45',
  '60',
  '75',
  '90',
  '105',
];

export const ANALYTICS_TYPE_DATA = ['Speakers', 'Reaction', 'Attention'];
export const LANGUAGE_DATA = ['Русский', 'English', 'Українська'];
